import { ROUTES } from '@/constants/routes/default';
import { getFullYear } from '@/helpers/date';
import Image from 'next/image';
import Link from 'next/link';

const FooterKD = ({ isAuthorized }: { isAuthorized: boolean }) => {
  return (
    <footer className="flex flex-col md:px-10 max-md:px-4 md:py-8 max-md:py-6 bg-kd-woodsmoke">
      <div className="flex justify-between items-center flex-wrap gap-2 m-auto max-w-290 w-full">
        <p className="text-white font-semibold max-md:text-2xl md:text-3xl md:max-w-100">
          Set your slots once and we&apos;ll watch the board for you
        </p>
        <a
          className={
            'flex items-center gap-2 font-bold text-white max-md:px-4 md:px-6 max-md:py-2 md:py-3 rounded-full no-underline default-transition bg-kd-persimmon hover:bg-kd-valencia'
          }
          href={isAuthorized ? ROUTES.profile : ROUTES.signup}
        >
          Tune my search{' '}
          <span className="text-xl" aria-hidden="true">
            →
          </span>
        </a>
      </div>
      <div className="max-w-290 w-full h-full flex justify-between items-center m-auto flex-wrap gap-4 max-md:flex-col max-md:items-start max-md:gap-5 border-t border-kd-mako pt-6 mt-6">
        <div>
          <Link href={ROUTES.home} aria-label="Koch Davis home">
            <Image
              width="160"
              height="38"
              src="https://assets.kochdavisjobs.com/kd/logo-2026-white.png"
              alt="Koch Davis"
              unoptimized
              priority
            />
          </Link>
        </div>
        <nav
          aria-label="Footer"
          className="w-fit flex flex-wrap gap-y-3 gap-x-15 text-kd-athens-gray text-sm"
        >
          <ul className="flex flex-col gap-3">
            <li>
              <Link
                className="block w-fit hover:text-kd-persimmon default-transition"
                href={ROUTES.jobs}
              >
                All jobs
              </Link>
            </li>
            <li>
              {isAuthorized ? (
                <Link
                  className="block w-fit hover:text-kd-persimmon default-transition"
                  href={ROUTES.profile}
                >
                  My search
                </Link>
              ) : (
                <Link
                  className="block w-fit hover:text-kd-persimmon default-transition"
                  href={ROUTES.signup}
                >
                  Setup search
                </Link>
              )}
            </li>
          </ul>
          <ul className="flex flex-col gap-3">
            <li>
              <Link
                className="block w-fit hover:text-kd-persimmon default-transition"
                href={ROUTES.home}
              >
                About
              </Link>
            </li>
            <li>
              <Link
                className="block w-fit hover:text-kd-persimmon default-transition"
                href={ROUTES.partners}
              >
                For employers
              </Link>
            </li>
          </ul>
          <ul className="flex flex-col gap-3">
            <li>
              <Link
                className="block w-fit hover:text-kd-persimmon default-transition"
                href={ROUTES.privacyPolicy}
              >
                Privacy Policy
              </Link>
            </li>
            <li>
              <Link
                className="block w-fit hover:text-kd-persimmon default-transition"
                href={ROUTES.termsOfUse}
              >
                Terms of Use
              </Link>
            </li>
          </ul>
        </nav>
      </div>
      <div className="flex justify-between items-center gap-2 flex-wrap m-auto max-w-290 w-full border-t border-kd-mako pt-6 mt-6">
        <p className="text-kd-pale-sky text-xs">
          © {getFullYear()} Koch Davis · Placing engineers in New York since 1978
        </p>
        <p className="text-kd-pale-sky text-xs">
          244 Fifth Avenue, New York, N.Y. 10001 ·{' '}
          <a
            className="hover:text-white default-transition"
            href="tel:8008740818"
            target="_blank"
            rel="noopener noreferrer"
          >
            800-874-0818
          </a>{' '}
          ·{' '}
          <a
            className="hover:text-white default-transition"
            href="mailto:kd@kochdavisjobs.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            kd@kochdavisjobs.com
          </a>
        </p>
      </div>
    </footer>
  );
};

export default FooterKD;
